import { render, staticRenderFns } from "./AppointmentNotification.vue?vue&type=template&id=b1d29610&scoped=true"
import script from "./AppointmentNotification.vue?vue&type=script&lang=js"
export * from "./AppointmentNotification.vue?vue&type=script&lang=js"
import style0 from "./AppointmentNotification.vue?vue&type=style&index=0&id=b1d29610&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d29610",
  null
  
)

export default component.exports